/* eslint-disable max-len */
/* eslint-disable max-len */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import userService from '../../services/user.services'
import { Auth } from 'aws-amplify';

const user = (localStorage.getItem('IdToken')!==null||sessionStorage.getItem('IdToken')!==null)
const initial = user ? true : false;

const initialState = {
    user: '',
    loading: true,
    initial_loading: false,
    error: '',
    success: '',
    access_token: '',
    email: '',
    loggedIn: initial,
}
export const loginUser = createAsyncThunk('user', async (body) => {
    // let res = await userService.login(body.email, body.password);
    // return res
})
const authSlice = createSlice({

    name: 'user',
    initialState,
    reducers: {
        addToken: (state, action) => {
            state.token = localStorage.getItem('token')
        },
        verifyOtp: (state, action) => {
            state.loggedIn = true
            state.email = action.payload
        },
        logIn:(state,action)=>{
            state.loggedIn=true
            state.email=action.payload
        },
        setUserType: (state, action) => {
            
            state.userType = action.payload

        
            state.initial_loading=false

        },
        handleClockIn:(state,action)=>{
            state.clock_in_out_facitilty=action.payload
        },
        handleLoading:(state, action) => {
            
            state.initial_loading=action.payload
        },
        logout: (state, action) => {
            //localStorage.clear()
            Auth.signOut()
            state.loggedIn = false
            state.email = '';
            state.userType=''
            //sessionStorage.clear()
        },
        updateAuth: (state, action) => {
            state.user = action.payload
        },
       
        
    },
    extraReducers: {
        // register user
        [loginUser.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [loginUser.fulfilled]: (state, action) => {
            state.loading = false;
            state.email=action.meta.arg.email
            if(!action.payload.error && action?.payload?.data?.success_status){
                state.success=action?.payload?.data?.message;
                if(action.payload?.data?.access_token!== ''){
                    state.access_token = action?.payload?.data?.access_token
                }else{
                    state.error='Failed'
                }

                state.error=action.payload.message?.message
            }else{
                state.error=action?.payload?.data?.message
          
            }      },
        [loginUser.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { addToken, verifyOtp,logIn, updateAuth,logout,setUserType,handleLoading,handleClockIn } = authSlice.actions;
export default authSlice.reducer